<template>
  <tr @mouseover="mouseOver" @mouseleave="mouseLeave" class="album-track poly-cursor-pointer">
    <td v-on:click="play" class="album-track-number has-text-centered">
      <span v-if="showState" class="icon is-small">
        <i v-if="isPlaying" class="mdi mdi-18px mdi-pause"></i>
        <i v-else class="mdi mdi-18px mdi-play"></i>
      </span>

      <span v-else class="is-family-monospace has-text-grey">
        {{ track.number }}.
      </span>
    </td>

    <td v-on:click="play" class="poly-truncate">
      <span v-bind:class="{ 'has-text-weight-semibold': showArtist }">
        {{ track.name }}
      </span>
      <template v-if="showArtist">
        <br/>
        <ul class="track-artists has-text-grey-light poly-truncate">
          <li
            v-for="(artist, index) in track.artists"
            v-bind:key="artist.id"
          >
            <span v-if="index > 0">, </span>
            <span class="artist-name has-text-grey-light">{{ artist.name }}</span>
          </li>
        </ul>
      </template>
    </td>

    <td class="has-text-centered poly-hidden-touch">
      <like-track v-bind:track="track" />
    </td>

    <td class="is-family-monospace has-text-right">
      {{ duration }}
    </td>
  </tr>
</template>

<script>
  import { playerStatuses } from '@/constants'

  import LikeTrack from '@/components/LikeTrack'

  const formatDuration = require('format-duration')

  export default  {
    name: 'AlbumTrack',
    data: function () {
      return  {
        hover: false
      }
    },
    props: ['track', 'status', 'showArtist'],
    components: {
      LikeTrack
    },
    computed: {
      isPlaying: function () {
        return this.status === playerStatuses.PLAYING
      },
      isPaused: function () {
        return this.status === playerStatuses.PAUSED
      },
      isStopped: function () {
        return this.status === playerStatuses.STOPPED
      },
      showState: function () {
        return this.hover || !this.isStopped
      },
      duration: function () {
        return formatDuration(this.track.duration * 1000)
      }
    },
    methods: {
      play: function () {
        if (this.isStopped) {
          this.$emit('play', this.track)
        } else {
          this.$store.commit('togglePlay')
        }
      },
      mouseOver: function () {
        this.hover = true
      },
      mouseLeave: function () {
        this.hover = false
      }
    }
  }
</script>

<style scoped>
  .album-track th, td {
    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;
  }

  .album-track td:last-child {
    padding-right: 0.8rem !important;
  }

  .album-track-number .icon {
    margin-left: -0.2rem !important;
  }

  .track-artists li { display: inline; }

  .artist-name {
    font-size: 0.9rem;
  }
</style>
